import React from "react";

const AttendanceChartUpdateCard = ({data}) => {
  return (
    <div className="p-1 w-full h-fit flex-col align-start justify-start g-2 radius-6 back-white">
      <span className="w-full text-align-center poppins color-grayColor">
        Attendance chart updated
      </span>

      <div className="flex-col align-start justify-start g-1">
        <div className="flex-row align-center justify-start g-05 pt-1 pb-1">
          <span className="poppins t-14 color-black">Time:</span>
          <span className="poppins t-14 color-grayColor">{data?.timestamp}</span>
        </div>
        <button type="button" className="actionBtn w-full">
          View Report
        </button>
      </div>
    </div>
  );
};

export default AttendanceChartUpdateCard;
